import { render, staticRenderFns } from "./certificate-dec.vue?vue&type=template&id=5eee732e&scoped=true"
import script from "./certificate-dec.vue?vue&type=script&lang=js"
export * from "./certificate-dec.vue?vue&type=script&lang=js"
import style0 from "./certificate-dec.vue?vue&type=style&index=0&id=5eee732e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eee732e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eee732e')) {
      api.createRecord('5eee732e', component.options)
    } else {
      api.reload('5eee732e', component.options)
    }
    module.hot.accept("./certificate-dec.vue?vue&type=template&id=5eee732e&scoped=true", function () {
      api.rerender('5eee732e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/components/certificate-dec.vue"
export default component.exports